// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clip-path[data-v-c6597bfe]{-webkit-clip-path:ellipse(90% 100% at 50% 100%);clip-path:ellipse(90% 100% at 50% 100%)}.bg-blur[data-v-c6597bfe]{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
